// src/pages/NotFoundPage.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { send } from "@emailjs/browser";
import { useTranslation } from "react-i18next";
import { logToSheet } from "../../utils/logToSheet";
import { EMAIL_CONFIG } from "../../config/emailConfig";
import "./NotFoundPage.css";

export default function NotFoundPage() {
  const { t, i18n } = useTranslation("notFoundPage");
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const langKey = React.useMemo(() => {
    if (i18n.language.startsWith("pt")) return "pt";
    if (i18n.language.startsWith("en")) return "en";
    return "es";
  }, [i18n.language]);

  const handleSubmit = (event) => {
    event.preventDefault();

    const config = EMAIL_CONFIG[langKey] || EMAIL_CONFIG.es;

    setStatus(t("status.sending"));

    send(
      config.serviceId,
      config.templateId,
      {
        email,
        about: t("form.about"),
      },
      config.publicKey,
    )
      .then(() => {
        setStatus(t("status.success"));
        logToSheet(email, "coming soon page");
        setEmail("");
      })
      .catch(() => {
        setStatus(t("status.error"));
      });
  };

  return (
    <main className="not-found-page">
      <section className="not-found-container">
        <span className="not-found-brand">ZY</span>

        <h1 className="not-found-title">{t("title")}</h1>

        <p className="not-found-message">{t("message")}</p>

        <form className="not-found-form" onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder={t("form.placeholder")}
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
          />

          <button type="submit">{t("form.button")}</button>
        </form>

        {status && <p className="not-found-status">{status}</p>}

        <Link to="/" className="not-found-button">
          {t("backHome")}
        </Link>
      </section>
    </main>
  );
}
